import { type IListPageChildProps } from "layouts/ListPageLayout";
import { useEffect } from "react";
import { type RouteComponentProps } from "react-router-dom";
import { useNavigate } from "react-router-dom-v5-compat";
import { ScreenMax } from "styles/antTheme/Variables";
import { useMediaQuery } from "usehooks-ts";

import { ListEntityType } from "utilities/list/list.types";
import { routes } from "utilities/routes";

import PageTitle from "commonComponents/utilities/PageTitle/PageTitle";

import { type SystemFilterType } from "handlers";

import BillList from "entity/bill/BillList/BillList";
import { BillListRouteView } from "entity/bill/common/BillListEnums";
import { useIsDraftBillsEffective } from "entity/bill/hooks/useIsDraftBillsEffective";

export interface IBillsListPageContentProps {
    listLayoutProps: IListPageChildProps;
    reactRouterProps: RouteComponentProps<{ view?: string }>;
    systemFilter: SystemFilterType | undefined;
    view?: string;
}

export const BillsListPageContent = ({
    listLayoutProps,
    reactRouterProps,
    systemFilter,
    view,
}: IBillsListPageContentProps) => {
    const navigate = useNavigate();
    const isDraftBillsEffective = useIsDraftBillsEffective();
    const isXsScreen = useMediaQuery(`(max-width: ${ScreenMax.xs}px)`);

    // Redirect InReview route to the new bill review queue page
    useEffect(() => {
        if (view === BillListRouteView.InReview) {
            navigate(routes.bill.getApprovalQueueLink(), { replace: true });
        }
    }, [view, navigate]);

    return (
        <>
            <PageTitle title="Bills" />
            <BillList
                {...reactRouterProps}
                {...listLayoutProps}
                entityType={ListEntityType.Payments}
                systemFilter={systemFilter}
                isDraftBillsEffective={isDraftBillsEffective}
                isXsScreen={isXsScreen}
            />
        </>
    );
};
